import { Component, EventEmitter, inject, OnDestroy, Output } from '@angular/core';
import { WelcomeBoxComponent } from '../welcome-box/welcome-box.component';
import { CommonModule } from '@angular/common';
import { GlobalService } from '../../services/common/global.service';
import { AvatarUtils } from '../../services/utils/avatar-utils';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';
import { SimplebarAngularModule } from 'simplebar-angular';
import { NgbTooltipModule } from '@ng-bootstrap/ng-bootstrap';
import { NavigationEnd, Router } from '@angular/router';
import { Subscription } from 'rxjs';
import { PortalTopNavComponent, PortalTopNavTab } from '../../../doctor-portal/components/common/portal-top-nav/portal-top-nav.component';

@Component({
  selector: 'app-top-bar-2',
  imports: [WelcomeBoxComponent, CommonModule, SimplebarAngularModule, NgbTooltipModule, PortalTopNavComponent],
  templateUrl: './top-bar-2.component.html',
  styleUrl: './top-bar-2.component.css',
})
export class TopBar2Component implements OnDestroy {
  private readonly dashboardStateKey = 'doctorDashboardV2State';
  @Output() settingsButtonClicked = new EventEmitter();
  @Output() openOnboardingOverview = new EventEmitter<{
    title: string;
    count: string;
    tab: string;
  }>();
  userSettings!: any;
  avatar: SafeHtml | null = null;
  isAvatar: boolean = false;

  private globalService = inject(GlobalService);
  private sanitizer = inject(DomSanitizer);
  private router = inject(Router);

  activeTab: PortalTopNavTab = 'dashboard';
  hasPatientOutcomesPermission = false;
  private routerSub: Subscription;

  constructor() {
    this.routerSub = this.router.events.subscribe((event) => {
      if (event instanceof NavigationEnd) {
        this.activeTab = this.resolveActiveTab(event.urlAfterRedirects);
      }
    });
    this.activeTab = this.resolveActiveTab(this.router.url);
  }

  private hasScreenPermission(screenName: string): boolean {
    const userPermissions = this.userSettings?.userPermissions;
    if (!userPermissions) {
      return false;
    }
    return userPermissions.some((permission: any) =>
      permission.screens?.some(
        (screen: any) => screen.screen_name === screenName && screen.is_assigned,
      ),
    );
  }

  private resolveActiveTab(url: string): PortalTopNavTab {
    if (url.startsWith('/dashboard/doctor/patient-outcomes')) {
      return 'patient-outcomes';
    }
    if (url.includes('/doctor-dashboard/referrals')) {
      return 'referrals';
    }
    return 'dashboard';
  }

  goToDashboard(): void {
    this.router.navigate(['/dashboard/doctor/doctor-dashboard']);
  }

  goToPatientOutcomes(): void {
    this.router.navigate(['/dashboard/doctor/patient-outcomes']);
  }

  goToReferrals(): void {
    this.router.navigate(['/dashboard/doctor/doctor-dashboard/referrals']);
  }

  goToCompliance(): void {
    this.router.navigate(['/dashboard/doctor/doctor-dashboard'], {
      queryParams: { focus: 'compliance' },
    });
  }

  ngOnDestroy(): void {
    this.routerSub?.unsubscribe();
  }

  ngOnInit(): void {
    this.userSettings = JSON.parse(this.globalService.getUserSettings());
    this.hasPatientOutcomesPermission = this.hasScreenPermission('Patients Outcome Dashboard');
    let thumbnail = this.userSettings.userInfo.imagePath;

    if (thumbnail == null || thumbnail == '' || thumbnail == 'undefined') {
      const avatarHtml = AvatarUtils.getInitialsWithColorForBar(
        this.userSettings.userInfo.first_name,
        this.userSettings.userInfo.last_name,
        false,
      );
      this.avatar = this.sanitizer.bypassSecurityTrustHtml(avatarHtml);
      this.isAvatar = true;
    }
  }

  getInitials(firstName: string, lastName: string): string {
    const first = firstName ? firstName.charAt(0).toUpperCase() : '';
    const last = lastName ? lastName.charAt(0).toUpperCase() : '';
    return first + last;
  }

  

  openHomeHealthConsent() {
    console.log('here')
    const url = this.router.serializeUrl(
      this.router.createUrlTree(['/dashboard/patientonboarding/other-programs']),
    );
    window.open(url, '_blank');
  }

  OpenOnboardingOverview() {
    const payload = {
      title: 'Document Center',
      count: 'Signed-Off',
      tab: 'documentcenter',
    };

    this.saveDashboardState('onboarding', payload);
    this.openOnboardingOverview.emit(payload);
  }

  private saveDashboardState(screen: string, payload: any): void {
    const existingState = this.loadDashboardState();
    const nextState = {
      currentScreen: screen,
      screens: {
        ...(existingState?.screens || {}),
        [screen]: payload,
      },
      filter: existingState?.filter || {},
      savedAt: new Date().toISOString(),
    };

    localStorage.setItem(this.dashboardStateKey, JSON.stringify(nextState));
  }

  private loadDashboardState(): any {
    try {
      const raw = localStorage.getItem(this.dashboardStateKey);
      return raw ? JSON.parse(raw) : null;
    } catch {
      return null;
    }
  }

  settingMenu() {
    this.settingsButtonClicked.emit();
  }
}
